export default [
  {
    answer: 1,
    questions: [
      'Определить настроение человека по фотографии может только человек.',
      'Современные технологии могут определить эмоции человека по фотографии или видео.',
    ],
  },
  {
    answer: 1,
    questions: [
      'Увидел рекламу нового устройства, быстрее покупай, будешь в классе самым модным.',
      'Не покупай товары непроверенных производителей.',
    ],
  },
  {
    answer: 1,
    questions: [
      'Используй везде один и тот же пароль — так точно его не забудешь.',
      'Используй разные пароли на всех сайтах приложениях на телефоне, где хранится важная информация.',
    ],
  },
]
